<div class="modal" [ngClass]="maximized? 'FullScren': '' " tabindex="-1" role="dialog"
  [ngStyle]="{'display':displayStyle}">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title text-primary" style="width: 93%; height: 100%;">
          <i class="fas fa-file-alt icon-header"></i>
          {{eventLabel}}: {{violationData.ViolationName}}
        </h4>
        <button type="button" class="btn hover-coursor" (click)="closePopup()">
          <i class="fal fa-times p-2" aria-hidden="true" data-bs-toggle="tooltip" data-bs-placement="top"
            title="{{closeLabel}}">
          </i>
        </button>
      </div>
      <div class="modal-body mx-2 px-3 custom-area contant-box-h">
        <div class="row">
          <div class="col-md-6" *ngIf="appConfig.EventPopUp.ProfilePic.Enable">
            <span class="font-sm f-bold py-2">{{profilePicLabel}}</span>
            <br />
            <img class="h-45vh" src="{{_profilePicUrl}}" />
          </div>

          <div class="col-md-6 position-relative" *ngIf="isCameraPicEnabled">
            <span class="font-sm f-bold py-2">{{cameraPicLabel}}</span>
            <img class="h-45vh" src="{{camPicURL}}" />
            <ng-image-fullscreen-view [images]="imageObject" [imageIndex]="selectedImageIndex" [show]="showFlag"
              (close)="closeEventHandler()"></ng-image-fullscreen-view>

            <button (click)="showLightbox('cameraPic')" type="button" *ngIf="camPicURL !== 'assets/images/no-data.svg'"
              class="btncameraPicMaximize btn hover-coursor p-0">
              <i class="" aria-hidden="true" title="{{maximizeLabel}}" data-bs-toggle="tooltip" data-bs-placement="top"
                [ngClass]="maximized? '': 'fal fa-expand' "></i>
            </button>
          </div>
        </div>

        <div class="row fullbox-img">
          <div *ngIf="isScreenshotEnabled" class="col-md-12 position-relative">
            <span class="font-sm f-bold py-2">{{screenshotLabel}}</span>
            <br />
            <img class="larger-img-h" src="{{screenshotURL}}" />
            <button (click)="showLightbox('screenshotUrl')" type="button"
              *ngIf="screenshotURL !== 'assets/images/no-data.svg'" class="btnscreenshotMaximize btn hover-coursor p-0">
              <i class="" aria-hidden="true" title="{{maximizeLabel}}" data-bs-toggle="tooltip" data-bs-placement="top"
                [ngClass]="maximized? '': 'fal fa-expand' "></i>
            </button>
          </div>

          <div *ngIf="isScreenRecordEnabled" class="col-md-12">
            <span class="font-sm f-bold py-2">{{screenRecordLabel}}</span>
            <br />
            <img class="larger-img-h " *ngIf="screenVideoURL == ''" src="assets/images/no-data.svg" />
            <video class="larger-img-h" *ngIf="screenVideoURL != ''" src="{{screenVideoURL}}"
              controls="controls"></video>
          </div>
          <div *ngIf="isCameraRecordEnabled" class="col-md-12">
            <span class="font-sm f-bold py-2">{{cameraRecordLabel}}</span>
            <br />
            <img class="larger-img-h" *ngIf="camVideoURL == ''" src="assets/images/no-data.svg" />
            <video class="larger-img-h" *ngIf="camVideoURL != ''" src="{{camVideoURL}}" controls="controls"></video>
          </div>
        </div>

        <div *ngIf="appConfig.EventPopUp.IP.Enable" class="row">
          <div class="col-md-12">
            <span class="font-sm f-bold py-2"> {{ipLabel}}:
              {{violationData.Ip}}
            </span>
          </div>
        </div>
        <ng-container *ngIf="geolocationEnabled && violationData.Latitude != null && violationData.Longitude != null">
          <div class="row">
            <div class="col-md-12">
              <span class="font-sm f-bold py-2">{{geolocationLabel}}</span>
              <br />
              <span class="font-sm f-bold py-2"> {{violationData.Latitude}}, {{violationData.Longitude}}</span>
              <app-map [Latitude]="violationData.Latitude" [Longitude]="violationData.Longitude"
                *ngIf="geolocationEnabled && violationData.Latitude != null && violationData.Longitude != null">
              </app-map>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="modal-footer py-2">
        <div class="w-100">
          <div class="form-group" [ngClass]="enableEscalate? '' : 'd-none'">
            <label class="f-bold font-sm" for="txtComments">{{commentsLabel}}</label>
            <label class="text-danger">*</label>
            <p *ngIf="violationData.StatusCode != -1" class="card-comments text-break">{{violationData.SenderComments}}
            </p>
            <textarea type="text" class="form-control font-sm text-break"
              *ngIf="violationData.StatusCode == -1 || violationData.StatusCode == 2" id="txtComments" required
              [(ngModel)]="comment" maxlength="300" placeholder="{{commentHereLabel}} ..."
              (input)="sanitizeInput($event)"></textarea>
          </div>

          <div class="form-group" [ngClass]="violationData.ApproverComments? '' : 'd-none'">
            <label class="f-bold font-sm" for="txtComments">{{superadminCommentsLabel}}</label>

            <p class="card-comments text-break">
              {{violationData.ApproverComments}}</p>
          </div>
        </div>

        <div>
          <div class="float-start position-absolute left-10" *ngIf="isAgreeDisagreeEnabled === true"
            style="width: 176px;display: flex;justify-content: space-between;align-items: center;">
            <button type="button" class="btn disagree" (click)="showAgreeDisagreeCommentsPopup(null)"
              *ngIf="currentViolationAgreeDisagreeStatus !== 3">
              <i class="fa-solid "
                [ngClass]="currentViolationAgreeDisagreeStatus === 4 ? 'fa-thumbs-up' : 'fa-thumbs-down'"></i>
              {{currentViolationAgreeDisagreeStatus === 4 ? agreedLabel : disagreedLabel}}
            </button>
            <button type="button" class="btn disagree" (click)="showAgreeDisagreeCommentsPopup(4)"
              *ngIf="currentViolationAgreeDisagreeStatus === 3">
              <i class="fa-regular fa-thumbs-up"></i>
              {{agreeLabel}}
            </button>
            <button type="button" class="btn disagree" (click)="showAgreeDisagreeCommentsPopup(5)"
              *ngIf="currentViolationAgreeDisagreeStatus === 3">
              <i class="fa-regular fa-thumbs-down"></i>
              {{disagreeLabel}}
            </button>
          </div>

          <div>
            <button type="button" class="btn button-primary mx-1 btn-escalate hover-coursor"
              [ngClass]="enableEscalate? '' : 'd-none'" [disabled]="disableEscalate" data-bs-toggle="tooltip"
              data-bs-placement="top" title="{{escalateLabel}}" (click)="showConfirmModal()">
              {{escalateLabel}}
            </button>
            <button type="button" class="btn button-danger mx-1 hover-coursor" data-bs-toggle="tooltip"
              data-bs-placement="top" title="{{closeLabel}}" (click)="closePopup()">
              {{closeLabel}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal" [ngStyle]="{'display':confirmApproval}" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-sm" role="document">
      <div class="modal-content">
        <div class="modal-header border-0">
          <h5 class="modal-title text-primary"> <i class="fal fa-file-alt icon-header" data-bs-toggle="tooltip"
              data-bs-placement="top" title="{{escalateLabel}}"></i> {{escalateLabel}}</h5>
          <button type="button" class="close btn hover-coursor" data-dismiss="modal" data-bs-toggle="tooltip"
            data-bs-placement="top" title="{{closeLabel}}" aria-label="Close" (click)="closeComfirm()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <p class="text-center">{{doYouWantToEscalateLabel}}</p>
        </div>
        <div class="modal-footer border-0">
          <button type="button" class="btn button-primary hover-coursor" (click)="sendForApproval()"
            data-bs-toggle="tooltip" data-bs-placement="top" title="{{escalateLabel}}">{{escalateLabel}}</button>
          <button type="button" class="btn button-danger hover-coursor" data-dismiss="modal" data-bs-toggle="tooltip"
            data-bs-placement="top" title="{{closeLabel}}" (click)="closeComfirm()">{{closeLabel}}</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal" [ngStyle]="{'display':openAgreeDisagreeCommentsPopup ? 'block' : 'none'}" tabindex="-1"
  role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="ps-3 d-flex text-primary">
        <i class="fas fa-file-alt icon-header "></i>
        <b class="font-md py-2">{{isCurrentViolationAgreeDisagreePending === true ?
          currentViolationAgreeDisagreePendingStatus === 5 ? disagreeWithViolationLabel : agreeWithViolationLabel :
          disagreedViolationLabel
          }}</b>
      </div>
      <div class="modal-body">
        <div style="width:100%;display: flex;">
          <span class="font-md py-2">{{eventLabel}}: <b class="font-md py-2">{{violationData.ViolationName}}
              ({{violationData.EventId}})</b></span>
        </div>
        <div
          *ngIf="isCurrentViolationAgreeDisagreePending === true && currentViolationAgreeDisagreePendingStatus === 5 && showBoundingBoxForDisagreeEvents() === true">
          <div style="width:100%;">
            <span class="font-md py-2">{{selectDisagreeAreaLabel}}</span>
          </div>
          <br />
          <div style="width:100%;display: flex;justify-content: center;align-items: center;">
            <div style="height: 250px;width: 320px;overflow: hidden;text-align: center;">
              <img src="#" id="agreeDisagreeCropperImage" style="max-width: 100%; max-height: 100%;" crossorigin />
            </div>
          </div>
          <br />
          <div style="width:100%;display: flex;justify-content: center;align-items: center;">
            <select [(ngModel)]="selectedDisagreedLabel">
              <option [ngValue]="label.value" *ngFor="let label of violationDisagreeLabels;">{{label.displayName}}
              </option>
            </select>
          </div>
          <br />
        </div>
        <div class="form-group"
          [ngClass]="currentViolationAgreeDisagreeStatus !== 3 && currentViolationAgreeDisagreeStatus !== 4 ? '' : 'd-none'">
          <label for="txtComments" class="f-bold font-sm text-break">{{commentsLabel}}</label>
          <p class="font-sm">{{violationData.RejectionComment}}</p>
        </div>
        <textarea
          [ngClass]="isCurrentViolationAgreeDisagreePending === true && currentViolationAgreeDisagreePendingStatus === 5  ? '' : 'd-none'"
          maxlength="300" [(ngModel)]="violationAgreeDisagreeComments" placeholder="{{commentsLabel}}" class="form-control"
          rows="3"></textarea>
      </div>

      <div class="justify-content-end px-3 pb-3 d-flex">
        <button type="button" class="btn button-primary me-2 hover-coursor"
          [ngClass]="isCurrentViolationAgreeDisagreePending === true && currentViolationAgreeDisagreePendingStatus !== 3 ? '' : 'd-none'"
          (click)="submitViolationCommentsForAgreeDisagree()">{{submitLabel}}</button>
        <button type="button" class="btn button-danger hover-coursor" data-dismiss="modal" data-bs-toggle="tooltip"
          (click)="hideAgreeDisagreeCommentsPopup()">{{closeLabel}}</button>
      </div>
    </div>
  </div>
</div>